/**
 * @fileoverview wsdot-border-crossings API - Core fetch functions and types only
 *
 * This module provides exports for fetch functions and types only (no React hooks).
 * Use this for backend/server-side code to avoid React Query dependencies.
 */

export * from "./borderCrossingData/borderCrossings";
export * from "./borderCrossingData/shared/borderCrossingData.input";
export * from "./borderCrossingData/shared/borderCrossingData.output";
